import React from 'react';
import { Helmet } from 'react-helmet-async';
import PortfolioHero from "../components/PortfolioComponents/PortfolioHero";
import PortfolioProjects from "../components/PortfolioComponents/PortfolioProjects";

const Portfolio = () => {
  const pageTitle = "Software Portfolio & Case Studies | Vikash Tiwari";
  const pageDescription = "Browse Android applications, Flutter cross-platform projects, and React/Next.js web solutions built by Vikash Tiwari. Detailed case studies, code repositories, and live architecture demos.";
  const siteUrl = "https://vikashtiwaridev.web.app/portfolio";
  const ogImageUrl = "https://vikashtiwaridev.web.app/og-portfolio.jpg";

  const structuredData = {
    "@context": "https://schema.org",
    "@type": "CollectionPage",
    "name": "Vikash Tiwari - Software Engineering Portfolio",
    "description": pageDescription,
    "url": siteUrl,
    "author": {
      "@type": "Person",
      "name": "Vikash Tiwari",
      "url": "https://vikashtiwaridev.web.app/"
    },
    "mainEntity": {
      "@type": "ItemList",
      "itemListElement": [
        {
          "@type": "ListItem",
          "position": 1,
          "name": "Android & Flutter Mobile Applications",
          "description": "Native and cross-platform mobile apps built with Kotlin, Flutter, and Firebase."
        },
        {
          "@type": "ListItem",
          "position": 2,
          "name": "Web Applications & Full-Stack Systems",
          "description": "Modern web interfaces and REST API integrations built with React and Next.js."
        }
      ]
    }
  };

  return (
    <>
      <Helmet>
        {/* Primary Metadata */}
        <title>{pageTitle}</title>
        <meta name="description" content={pageDescription} />
        <link rel="icon" type="image/x-icon" href="https://vikashtiwaridev.web.app/VikashTiwariIcon.png" />
        <meta name="keywords" content="Vikash Tiwari Portfolio, Android Apps, Flutter Case Studies, React Developer Projects, Kotlin Apps, Mobile App Developer India, Vikash Tiwari, Software Developer, Android Developer, Next.js Developer, React Portfolio, Firebase Solutions, Freelance Software Developer,
        Hire Software Developer,
Hire React Developer,
Hire React.js Developer,
Hire Next.js Developer,
Hire Flutter Developer,
Hire Android Developer,
Hire Web Developer,
Hire Full Stack Developer,
Remote Software Developer,
Freelance Developer India,
Freelance Developer Delhi,
Freelance Developer Noida,

Software Developer India,
Software Developer Delhi,
Software Developer Delhi NCR,
Software Developer Noida,

Software Consultant,
Software Consultant India,
Software Consultant Delhi,
Software Consultant Noida,

Software Development,
Custom Software Development,
Business Software Development,
Enterprise Software,
Software Development Company India,
Software Development Company Delhi,
Software Development Company Noida,
Software Development Company Ghaziabad,

Website Development Company,
Website Development Delhi,
Website Developer Noida,
Web Application Development,
Responsive Website Development,
SEO Friendly Website,
Performance Optimization,
PWA Development,

React.js Developer,
React Frontend Developer,
React Development Services,
React Website Development,
React Freelancer,
React Developer Noida,

Next.js Developer,
Next.js Development,
Next.js Website Development,
Next.js Expert,
Next.js Freelancer,

Flutter Developer,
Flutter App Development,
Flutter Freelancer,
Flutter App Developer India,
Flutter Consulting,
Cross Platform App Development,

Android Developer,
Android App Development,
Mobile App Development,
Mobile App Development Company,
Mobile App Developer India,
iOS App Development,

Node.js Developer,
Express.js,
MongoDB,
Firebase,
Supabase,
REST API,
JavaScript,
TypeScript,
React.js,
Next.js,
Node.js,
Tailwind CSS,
Shadcn UI,

Startup Software Developer,
Startup MVP Development,
Startup MVP Developer,
MVP Developer,
Build Startup MVP,
Prototype Development,
Product Development,
Startup App Development,
Startup Tech Partner,
Technical Co-Founder,
SaaS MVP,
SaaS Development,

AI Chatbot Developer,
Custom AI Chatbot,
AI Chatbot Development,
AI Automation,
Business Automation,
OpenAI Integration,
Gemini API Integration,
Build AI Chatbot for Business,

CRM Development,
ERP Development,
Cloud Application Development,

Hire Freelance React Developer,
Hire Next.js Freelancer,
Hire Flutter Developer India,
Hire Remote React Developer,
Hire Full Stack Developer India,
Best Freelance Software Developer,
React Website Development Company,
Flutter Mobile App Development Services,
Website Development for Startups,
Custom Software Development Company India,
Startup Software Development Company,

Vikash Tiwari,
Vikash Tiwari Portfolio,
Vikash Tiwari Developer,
Vikash Tiwari Software Developer,
Vikash Tiwari React Developer,
Vikash Tiwari Next.js Developer,
Vikash Tiwari Flutter Developer,
Vikash Tiwari Android Developer,
Vikash Tiwari AI Developer,
Vikash Tiwari Web Developer,
Vikash Tiwari Mobile App Developer,
Vikash Tiwari Software Consultant" />
        <meta name="author" content="Vikash Tiwari" />
        <link rel="canonical" href={siteUrl} />

        {/* Open Graph */}
        <meta property="og:type" content="website" />
        <meta property="og:url" content={siteUrl} />
        <meta property="og:title" content={pageTitle} />
        <meta property="og:description" content={pageDescription} />
        <meta property="og:image" content={ogImageUrl} />

        {/* Twitter */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:url" content={siteUrl} />
        <meta name="twitter:title" content={pageTitle} />
        <meta name="twitter:description" content={pageDescription} />
        <meta name="twitter:image" content={ogImageUrl} />

        {/* Structured Data (CollectionPage / ItemList) */}
        <script type="application/ld+json">
          {JSON.stringify(structuredData)}
        </script>
      </Helmet>

      <main>
        <PortfolioHero />
        <PortfolioProjects />
      </main>
    </>
  );
};

export default Portfolio; // Ensure named/default export aligns with route imports